import React from "react";
import '../../../styles/document.css';
import Translator from "../../../services/Translator";
import FlagXMK from "../../flags/FlagXMK";
import QRCode from "react-qr-code";
import backgroundImage from "../../../assets/images/documents/identity-card-v2.png";


export default function SeriesA({document, lang}: any)
{
    return (
        <div>
            <div className="container-fluid" style={{background: 'rgb(134,170,202,0.6) linear-gradient(113deg, rgba(134,170,202,0.6) 0%, rgba(199,180,124,0.6) 100%)', padding: '20px', fontSize: '0.9rem'}}>
                <div className="row" style={{background: 'url(\'' + backgroundImage + '\') no-repeat top right', backgroundSize: 'contain'}}>
                    <div className="col-5">
                        <img src={'data:image/png;base64,' + document.photo}
                             alt={document.given_names + ' ' + document.surname}
                             className="img-fluid"
                        />

                        <FlagXMK />
                        {document.identity_card_number.substring(0, 3)} {document.identity_card_number.substring(3, 8)}
                    </div>

                    <div className="col-7">

                        <strong>{Translator.trans(lang, "documents.identity_card.given_names")}</strong>
                        {document.given_names}

                        <strong>{Translator.trans(lang, "documents.identity_card.surname")}</strong>
                        {document.surname}

                        <strong>ESEO</strong>
                        {document.eseo}
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row" style={{paddingBottom: '30px'}}>
                    <div className="col">
                    </div>
                </div>

                <div className="row" style={{paddingBottom: '30px'}}>
                    <div className="col-6">
                        <strong>{Translator.trans(lang, "documents.identity_card.date_of_birth")}</strong>
                        {document.date_of_birth}
                    </div>

                    <div className="col-6">
                        <strong>{Translator.trans(lang, "documents.identity_card.sex")}</strong>
                        {document.sex}
                    </div>
                </div>

                <div className="row" style={{paddingBottom: '30px'}}>
                    <div className="col-6">
                        <strong>{Translator.trans(lang, "documents.identity_card.date_of_issue")}</strong>
                        {document.date_of_issue}
                    </div>

                    <div className="col-6">
                        <strong>{Translator.trans(lang, "documents.identity_card.expiry_date")}</strong>
                        {document.expiry_date}
                    </div>
                </div>

                <div className="row" style={{paddingBottom: '30px'}}>
                    <div className="col-12">
                        <div style={{width: '200px', height: '200px', background: 'white', padding: '20px', margin: '20px auto'}}>
                            <QRCode value={document.qr} style={{width: '160px', height: '160px'}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
